<template>
<div v-if="!isPageLoading">
    <div v-if="hasGlobalAccess && (user != null || currentuser != null)">
        <v-card>
            <v-card-title v-show="!isLoggedInUserActive">
                <label style="color: red">{{ $t("msguserisnotactive") }}</label>
            </v-card-title>
            <v-data-table :headers="headers" :items="plants" :search="search" v-show="isLoggedInUserActive" :footer-props="{
            itemsPerPageOptions: tableItemsPerPage,
            itemsPerPageText: rowsperpage,
          }" :options="options">
                <template v-slot:top>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card light flat>
                                    <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-progress-circular indeterminate color="primary" v-show="deleteinProgress"></v-progress-circular>
                                        <v-btn color="blue darken-1" text @click="closeDelete" v-show="!deleteinProgress">Close</v-btn>
                                        <v-btn color="blue darken-1" text @click="deleteItemConfirm" v-show="!deleteinProgress">OK</v-btn>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                    <v-toolbar flat dense>
                        <h3>{{ $t("plants") }}</h3>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">{{ $t("new") }}</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                    <v-spacer></v-spacer>
                                    <v-icon @click="close(1)">close</v-icon>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="8" md="8">
                                                <v-text-field v-model="editedItem.plant" v-bind:label="$t('newplant') + ' *'"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="8" md="8">
                                                <v-text-field v-model="editedItem.otherInfo" v-bind:label="$t('otherinfo')"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn color="blue darken-1" text @click="close(1)">{{
                      $t("cancel")
                    }}</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" dark class="mb-2" @click="save">{{
                      $t("save")
                    }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-text-field v-model="search" append-icon="mdi-magnify" v-bind:label="$t('searchall')" single-line hide-details></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                </template>
                <template v-slot:no-data>
                    <v-alert border="right" colored-border type="error" elevation="2">
                        {{ $t("norecordsfound") }}
                    </v-alert>
                </template>
            </v-data-table>
        </v-card>
    </div>
    <div v-else-if="user != null || currentuser != null">
        <v-alert outlined type="warning" prominent border="left">
            {{ $t("accessdenied") }}
        </v-alert>
    </div>
</div>
<div v-else>
    <v-progress-linear indeterminate color="teal" rounded height="8"></v-progress-linear>
</div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import i18n from "@/plugins/i18n";
import requestsMixin from "@/mixins/requests"
export default {
    mixins: [requestsMixin],
    data() {
        return {
            search: "",
            plants: [],
            dialog: false,
            statusmessages: [],
            isSucess: false,
            editedIndex: -1,
            selecttedplant: 0,
            editedItem: {
                id: 0,
                plant: "",
                otherInfo: "",
                updatedBy: "",
                updatedOn: new Date().toISOString(),
            },
            defaultItem: {
                id: 0,
                plant: "",
                otherInfo: "",
                updatedBy: "",
                updatedOn: new Date().toISOString(),
            },
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
            searchUser: null,
            entries: [],
            useraccess: [],
            currentuser: [],
            isPageLoading: true,
            user: null,
            tableItemsPerPage: [25, 50, 100, -1],
            options: null,
               deleteinProgress: false,
            dialogDelete: false,
        };
    },
    mounted() {
        this.getPlantsFromAPI();
    },
    methods: {
        getPlantsFromAPI() {
            var self = this;
            self.isPageLoading = true;
            self.user = self.$store.state.userDetails;
            const link = window.apiurl + "/plants";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.plants = response.data;
                })
                .catch((error) => console.log(error));

            if (self.user != null) {
                const link2 =
                    window.apiurl + "/userheadcount/myview/" + self.user.userEmail;
                axios
                    .get(link2, {
                        withCredentials: true,
                        headers: self.requestHeaders
                    })
                    .then((response) => {
                        self.useraccess = response.data;
                        i18n.locale = self.useraccess[0].language;
                        if (self.useraccess[0].rowsPerPage != null) {
                            var rowsPrPg =
                                self.useraccess[0].rowsPerPage == "All" ?
                                -1 :
                                parseInt(self.useraccess[0].rowsPerPage);
                            self.options = {
                                itemsPerPage: rowsPrPg,
                            };
                        } else {
                            self.options = {
                                itemsPerPage: 25,
                            };
                        }
                        self.isPageLoading = false;
                    })
                    .catch((error) => console.log(error));
            } else {
                self.getUser();
            }
        },
        getUser() {
            var self = this;
            axios
                .get(window.apiurl + "/usercontext", {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.currentuser = response.data;
                    const link4 =
                        window.apiurl +
                        "/userheadcount/myview/" +
                        self.currentuser.userEmail;
                    axios
                        .get(link4, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response1) => {
                            self.useraccess = response1.data;
                            i18n.locale = self.useraccess[0].language;
                            self.isPageLoading = false;
                        })
                        .catch((error) => console.log(error));
                })
                .catch((error) => console.log(error));
        },
        close(isCancel) {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
            if (isCancel == 1) {
                this.$toast.clear();
            }
        },
        editItem(item) {
            this.editedIndex = this.plants.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
         deleteItem(item) {
            this.editedIndex = this.plants.indexOf(item);
            this.editedItem.id = item.id
            this.dialogDelete = true;
            this.deleteinProgress = false;
        },
        deleteItemConfirm() {
            this.deleteinProgress = true;
                var self = this;
                const link = window.apiurl + "/plants/delete/" +  this.editedItem.id;
                axios
                    .delete(link, { withCredentials: true, headers: self.requestHeaders })
                    .then(function (response) {
                        if (response.data.isSucess) {
                            self.plants.splice(self.editedIndex, 1);
                            //alert(self.$t(""));
                            self.$toast.clear();
                            self.$toast.success(self.$t("msgrecorddeleted"));
                        } else {
                            var index1 = 0;
                            for (
                                index1 = 0; index1 < response.data.messages.length; index1++
                            ) {
                                self.statusmessages.push(response.data.messages[index1]);
                            }
                             self.$toast.clear();
                            self.$toast.error(self.statusmessages[0]);
                        }
                        self.closeDelete()
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
        },
        closeDelete() {
            this.dialogDelete = false;
        },
        save() {
            var self = this;
            if (this.editedItem.plant == "") {
                self.$toast.clear();
                self.$toast.error(this.$t("errfillrequiredfields"), {
                    timeout: false,
                });
            } else {
                this.editedItem.updatedBy = this.user.userEmail;
                var object = null;

                if (self.editedIndex > -1) {
                    const link = window.apiurl + "/plants/update";
                    axios
                        .put(link, this.editedItem, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response) => {
                            console.log(response.data);
                            if (response.data.isSucess) {
                                //alert(self.$t(""));
                                self.$toast.clear();
                                self.$toast.success(self.$t("msgplantedited"));
                                Object.assign(self.plants[self.editedIndex], self.editedItem);
                            } else {
                                var index = 0;
                                for (
                                    index = 0; index < response.data.messages.length; index++
                                ) {
                                    self.statusmessages.push(response.data.messages[index]);
                                }
                            }
                            self.close();
                        })
                        .catch((error) => console.log(error));
                } else {
                    if (this.plants.find((x) => x.plant == this.editedItem.plant) != null)
                        object = this.plants.find((x) => x.plant == this.editedItem.plant);
                    if (object == null) {
                        const link = window.apiurl + "/plants/create";
                        axios
                            .post(link, this.editedItem, {
                                withCredentials: true,
                                headers: this.requestHeaders
                            })
                            .then(function (response) {
                                if (response.data.isSucess) {
                                    const newPlant = {
                                        id: 0,
                                        plant: "",
                                        otherInfo: "",
                                        updatedBy: "",
                                        updatedOn: new Date(),
                                    };
                                    newPlant.id = response.data.plants.id;
                                    newPlant.plant = response.data.plants.plant;
                                    newPlant.otherInfo = response.data.plants.otherInfo;
                                    newPlant.updatedBy = response.data.plants.updatedBy;
                                    newPlant.updatedOn = response.data.plants.updatedOn;
                                    self.plants.push(newPlant);
                                    //alert(self.$t(""));
                                    self.$toast.clear();
                                    self.$toast.success(self.$t("msgplantadded"));
                                    self.close();
                                } else {
                                    var index = 0;
                                    for (
                                        index = 0; index < response.data.messages.length; index++
                                    ) {
                                        self.statusmessages.push(response.data.messages[index]);
                                    }
                                }
                            })
                            .catch(function (err) {
                                console.log(err);
                            });
                        this.close();
                    } else {
                        //alert("Plant already exists");
                        self.$toast.clear();
                        self.$toast.error(this.$t("errplantexists"), { timeout: false });
                    }
                }
            }
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${month}/${day}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        exportexcel() {
            //this.download = true
            this.JSONToCSVConvertor(this.users, "Plants - Report", true);
        },
        JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData =
                typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

            var CSV = "";
            //Set Report title in first row or line

            CSV += ReportTitle + "\r\n\n";

            //This condition will generate the Label/Header
            if (ShowLabel) {
                var row = "";

                //This loop will extract the label from 1st index of on array
                for (var index in arrData[0]) {
                    //Now convert each value to string and comma-seprated
                    row += index + ",";
                }

                row = row.slice(0, -1);

                //append Label row with line break
                CSV += row + "\r\n";
            }

            //1st loop is to extract each row
            for (var i = 0; i < arrData.length; i++) {
                var row = "";

                //2nd loop will extract each column and convert it in string comma-seprated
                for (var index in arrData[i]) {
                    row += '"' + arrData[i][index] + '",';
                }

                row.slice(0, row.length - 1);

                //add a line break after each row
                CSV += row + "\r\n";
            }

            if (CSV == "") {
                //alert("Invalid data");
                self.$toast.clear();
                self.$toast.error(this.$t("errinvaliddata"), { timeout: false });
                return;
            }

            var filename = "Plants.csv";
            var blob = new Blob([CSV], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ?
                this.$t("newplant") :
                this.$t("editplant");
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        // user() {
        //   return this.$store.state.userDetails;
        // },
        hasGlobalAccess() {
            var globalaccess = false;
            var filterPlant = [];
            filterPlant = this.useraccess.filter((x) => x.plant == "Global");
            if (filterPlant != null && filterPlant.length > 0) {
                globalaccess = true;
            }
            return globalaccess;
        },
        rowsperpage() {
            return this.$t("rowsperpage");
        },
        isLoggedInUserActive() {
            var isuseractive = false;
            if (this.useraccess.length > 0) {
                this.useraccess.forEach(function (elem, index) {
                    if (elem.isActive == "Y") {
                        isuseractive = true;
                    }
                });
            }
            return isuseractive;
        },
        headers() {
            return [{
                    text: this.$t("plant"),
                    align: "start",
                    value: "plant",
                },
                { text: this.$t("otherinfo"), value: "otherInfo" },
                { text: this.$t("updatedby"), value: "updatedBy" },
                { text: this.$t("updatedon"), value: "updatedOn" },
                { text: this.$t("actions"), value: "action", sortable: false },
            ];
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        date(val) {
            this.dateFormatted = this.formatDate(this.date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ./src/components/Plants.vue